import { difference, shuffle } from 'lodash-es';
import { audioManagerPlaySound } from './AudioManager.js';
import { dictionaryCookieAddWord, dictionaryCookieReset } from './DictionaryCookie.js';
import Jigsaw from './jigsaw/Jigsaw.js';

import iconAudioSvg from '../images/icon-audio.svg?raw';
import { dispatchWindowEvent } from "./_utils.js";

export default class DictionaryGame
{
    constructor()
    {
        this.outerContainer = document.querySelector( '.dictionary-game-container' );

        if ( !this.outerContainer ) {
            // not on this page
            return;
        }


        this.currentConfig = window?.DictionnaireGameConfig ?? null;

        if ( !this.currentConfig ) {
            console.error( "[DictionaryGame] I can't seem to find the info for the activity" );
            return;
        }

        this.activeWord = null;

        this.gamePart1                 = this.outerContainer.querySelector( '.game-part.game-part-1' );
        this.part1WordsContainer       = this.gamePart1.querySelector( '.words' );
        this.btnStartJigsaw            = this.gamePart1.querySelector( '.btn-start-jigsaw' );
        this.gamePart2                 = this.outerContainer.querySelector( '.game-part.game-part-2' );
        this.gameInstrcutionsContainer = this.gamePart2.querySelector( '.game-instructions' );
        this.gameSurface               = this.gamePart2.querySelector( '.jigsaw-outer' );

        this.gameSuccessSection          = this.outerContainer.querySelector( '.game-success-section' );
        this.gameSuccessMessage          = this.gameSuccessSection.querySelector( '.success-message' );
        this.gameSuccessImageContainer   = this.gameSuccessSection.querySelector( '.success-image-container' );
        this.gameSuccessImageBgContainer = this.gameSuccessImageContainer.querySelector( '.bg-image' );
        this.gameSuccessImageFgContainer = this.gameSuccessImageContainer.querySelector( '.fg-image' );

        this.setupCompletedWords();

        this.chooseWords( 3 );
        this.injectWords();

        this.btnStartJigsaw.addEventListener( 'click', () =>
        {
            this.beginGame( this.activeWord );
        }, { once: true } )

        // temp
        // document.querySelector( '.btn-debug-reset-cookie' ).addEventListener( 'click', () => dictionaryCookieReset() );
    }


    bindAudioEvents() {


    }

    setupCompletedWords()
    {

        this.completedWords = [];

        const allCompletedWords = window?.SavoirsLegendairesUserWords ?? [];

        if ( typeof allCompletedWords !== 'undefined' ) {
            allCompletedWords
                .filter( word => word.nation === this.currentConfig.currentNation )
                .forEach( word => this.completedWords.push( word.word ) );
        }

        // console.log( ' this.completedWords', this.completedWords )
    }


    chooseWords( howMany = 3 )
    {

        this.wordsNotComplete = window.DictionnaireGameConfig.mots.mots.filter( word => {
            return !this.completedWords.includes( word.slug );
        } );

        // console.log( 'this.wordsNotComplete', window.DictionnaireGameConfig.mots.mots, this.wordsNotComplete );


        // at one point, we need to start
        if ( this.wordsNotComplete.length === 0 ) {
            this.wordsNotComplete = window.DictionnaireGameConfig.mots.mots;
        }
        else if ( this.wordsNotComplete.length < 3 ) {
            const howManyNeeded = 3 - this.wordsNotComplete.length;
            for ( let i = 0; i < howManyNeeded; i++ ) {
                this.wordsNotComplete.push( window.DictionnaireGameConfig.mots.mots[ i ] );
            }
        }

        this.wordsForGame = this.wordsNotComplete.sort( () => 0.5 - Math.random() ).slice( 0, howMany );

        const shuffledWords = shuffle( this.wordsForGame );
        this.activeWord     = shuffledWords[ 0 ];
        this.fakeWord1      = shuffledWords[ 1 ];
        this.fakeWord2      = shuffledWords[ 2 ];

        // console.log( '     this.wordsForGame', this.wordsForGame, {
        //     activeWord: this.activeWord,
        //     fakeWord1 : this.fakeWord1,
        //     fakeWord2 : this.fakeWord2,
        // } )
    }

    injectWords()
    {
        if ( this.wordsForGame.length < 1 ) {
            alert( 'Not enough words to work with' );
            return;
        }
        this.wordsForGame.forEach( word => this.injectWord( word ) );
    }

    injectWord( word )
    {
        // const iconAudioSrc = new URL( '../images/icon-audio.svg', import.meta.url ).href;

        const wordContainer = document.createElement( 'button' );
        wordContainer.type  = 'button';
        wordContainer.classList.add( 'word-container' );


        // start game button
        const btn = document.createElement( 'div' );
        btn.classList.add( 'dictionary-game', 'btn-dictionary-game-part-1' );
        btn.setAttribute( 'data-nation', word.nation );
        btn.setAttribute( 'data-word', this.currentConfig.nation );
        btn.dataset.wordInfo = word;


        const elFrenchWord = document.createElement( 'span' );
        elFrenchWord.classList.add( 'mot-francais' );
        elFrenchWord.innerHTML = word.francais;

        btn.appendChild( elFrenchWord );


        const elImageContainer = document.createElement( 'span' );
        elImageContainer.classList.add( 'image-container' );

        const img = document.createElement( 'img' );
        img.src   = word.image_masked;

        elImageContainer.appendChild( img );
        btn.appendChild( elImageContainer );


        // listen
        const btnListenTranslation = document.createElement( 'span' );
        btnListenTranslation.classList.add( 'btn-mot-traduit' );


        const elTranslatedWord = document.createElement( 'span' );
        elTranslatedWord.classList.add( 'mot-traduit' );
        elTranslatedWord.innerHTML = word.word;

        btnListenTranslation.appendChild( elTranslatedWord );

        const spanIconListen = document.createElement( 'span' );
        spanIconListen.classList.add( 'icon-listen-container' );
        //
        //
        // const iconAudio = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // iconAudio.innerHTML = iconAudioSvg.innerHTML;

        spanIconListen.innerHTML = iconAudioSvg;
        btnListenTranslation.appendChild( spanIconListen );


        wordContainer.appendChild( btn );
        wordContainer.appendChild( btnListenTranslation );

        this.part1WordsContainer.appendChild( wordContainer );

        wordContainer.addEventListener( 'click', () =>
        {
            audioManagerPlaySound( word.translation_audio );
        } );

    }


    beginGame()
    {

        this.gamePart1.style.display = 'none';
        this.gamePart2.style.display = 'block';

        // console.log( 'Beginning game with ', this.activeWord );

        this.gameInstrcutionsContainer.innerHTML = this.activeWord.jigsaw_intro;


        this.prepareJigsaw();

        const nationTitle = document.querySelector( '.game-part-2 .nation-title' );
        if ( nationTitle ) {
            nationTitle.scrollIntoView();
            // console.log( 'scrolling to ', nationTitle );
        }


        // temp
        // const addWordButton = document.querySelector( '.btn-debug-add-word' );
        // if ( addWordButton ) {
        //     addWordButton.addEventListener( 'click', () => dictionaryCookieAddWord(
        //         this.activeWord.slug, this.currentConfig.currentNation ) );
        //     addWordButton.style.display = 'inline-block';
        // }

        window.addEventListener( 'jigsaw:begin', () => {
            // console.log( 'jigsaw:begin', this.activeWord, this.activeWord?.translation_audio ?? null )

            setTimeout(
                () => {
                    dispatchWindowEvent( 'audiomanager:playsound', {
                        url: this.activeWord?.translation_audio ?? null,
                    } )
                },
                (parseInt( SavoirsCopydeck?.dictionary_game?.delay_before_saying_translated_word_in_seconds ?? 3 ) + 2 ) * 1000,
            )

        } );


        window.addEventListener( 'jigsaw:win', () => {

            this.winGame();

            dispatchWindowEvent( 'audiomanager:playsound', {
                url: this.activeWord?.jigsaw_audio_win ?? null,
            } )
        } );
    }

    prepareJigsaw()
    {


        const jigsawCanvas = this.gameSurface.querySelector( '.jigsaw-canvas' );
        // console.log( 'this.wordsForGame', this.wordsForGame )
        jigsawCanvas.setAttribute( 'data-main-image', this.activeWord.image_puzzle )
        // jigsawCanvas.setAttribute( 'data-fake-image1', this.fakeWord1.image_puzzle )
        // jigsawCanvas.setAttribute( 'data-fake-image2', this.fakeWord2.image_puzzle )
        this.jigsaw = new Jigsaw( this.gameSurface );

    }

    winGame()
    {

        // console.log( 'winGame' )


        this.gameSuccessMessage.innerHTML = this.activeWord.jigsaw_success;


        const bgImage = document.createElement( 'img' );
        this.gamePart2.classList.add( 'won' );

        setTimeout( () => {

            this.gamePart2.classList.add( 'hide' );

            bgImage.addEventListener( 'load', () => {
                // setTimeout( () => {
                this.gameSuccessImageContainer.classList.add( 'won' );
                // }, 500 )
            } )
            bgImage.src = this.activeWord.image_win;
            this.gameSuccessSection.classList.add( 'won' );

            this.gameSuccessImageBgContainer.appendChild( bgImage );


            this.gameSuccessMessage.scrollIntoView( { behavior: "smooth", block: "start", inline: "nearest" } );
        }, 500 )

        dictionaryCookieAddWord( this.activeWord.slug, this.currentConfig.currentNation );

    }
}
